import React from 'react'
import { Location } from 'history'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'
import { RouteProps, routes } from 'constants/routes'

// Components
import IndexLayout, { Title, Subtitle } from 'components/IndexLayout'

import SsoSignInForm from './SsoSignInForm'

// Utils
import { useQueryParams } from 'utils'
import { sourceToSsoSignInSource } from '../../operations'

// Styles
import { SsoInformationAndFaqWrapper, StyledLink } from './SsoSignInView.styles'

const SsoSignInView: React.FC<RouteProps<'SSO_SIGN_IN'>> = props => {
  const { state } = props.location as Location<{ from?: Location }>
  const { source = 'cloud', team: teamName } = useQueryParams<'SSO_SIGN_IN'>()

  const formSource = sourceToSsoSignInSource[source] ?? 'cloud'
  const isSourceSketchApp = source === 'sketch'

  return (
    <IndexLayout
      headerLink={isSourceSketchApp ? 'none' : 'sign-up'}
      blockLogoLink={isSourceSketchApp}
      variant="teal">
      <Title>Hello! Enter an SSO Shortname</Title>
      <Subtitle>
        Your Admin will send you an SSO Shortname that you’ll use to sign in to
        your organization’s Workspace. Enter it here.
      </Subtitle>
      <SsoSignInForm
        source={formSource}
        teamName={teamName}
        from={state?.from?.pathname}
      />
      <SsoInformationAndFaqWrapper>
        {!isSourceSketchApp && (
          <StyledLink
            variant="tertiary"
            isUnderlined
            to={{ pathname: routes.SIGN_IN.create({}), state }}>
            Sign in with email and password
          </StyledLink>
        )}
        <StyledLink
          href={`${SKETCH_WEBSITE}/business-plan/what-is-sso/`}
          target="_blank"
          rel="noopener noreferrer"
          variant="tertiary"
          isUnderlined
          external>
          Learn about Single Sign-On (SSO)
        </StyledLink>
      </SsoInformationAndFaqWrapper>
    </IndexLayout>
  )
}

export default SsoSignInView
